module.exports = __webpack_public_path__ + "static/media/yes-icon.3850ec5b.svg";